module.exports = __webpack_public_path__ + "static/media/Slide04.93a17b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide04.png
// module id = 1626
// module chunks = 0